import Model from '@/store/model';
import Level from './level';
import MyResults from './my_results';
import AbInfo from './ab_info';
import TutorialAbInfo from './tutorial_ab_info';
import Achievement from './achievement';
import SkillPoint from './skill_point';
import State from './state';
import ClassroomInfo from './classroom_info';
import UserVariables from './user_variables';

class User extends Model {
  map(json) {
    super.map(json);

    if (json !== undefined && json !== null) {
      if (json && json.level !== undefined && json.level !== null) {
        this.level = new Level();
        try {
          this.level.map(json.level);
        } catch (error) {
          console.log(error);
        }
      }

      if (json.my_results !== undefined && json.my_results !== null) {
        this.myResults = new MyResults();
        this.myResults.map(json.my_results);
      }

      if (json.ab_info !== undefined && json.ab_info !== null) {
        this.abInfo = new AbInfo();
        this.abInfo.map(json.ab_info);
      }

      if (json.tutorial_ab_info !== undefined && json.tutorial_ab_info !== null) {
        this.tutorialAbInfo = new TutorialAbInfo();
        try {
          this.tutorialAbInfo.map(json.tutorial_ab_info);
        } catch (error) {
          console.log(error);
        }
      }

      if (json.current_achivements !== undefined && json.current_achivements !== null) {
        this.mapArray('currentAchivements', json.current_achivements, Achievement);
      }

      if (json.skill_point !== undefined && json.skill_point !== null) {
        this.skillPoint = new SkillPoint();
        this.skillPoint.map(json.skill_point);
      }

      if (json.state !== undefined && json.state !== null) {
        this.state = new State();
        this.state.map(json.state);
      }
      if (json.classroom_info !== undefined && json.classroom_info !== null) {
        this.classroomInfo = new ClassroomInfo();
        this.classroomInfo.map(json.classroom_info);
      }
      if (json.user_variables !== undefined && json.user_variables !== null) {
        this.userVariables = new UserVariables();
        this.userVariables.map(json.user_variables);
      }
    }
  }
}
export default User;
